const config = {
  url: '/page/:id',
  getTitle: id => id === 'create' ? 'Создание страницы' : 'Редактирование страницы',
  getApiUrl: id => id === 'create' ? '/pages' : `/pages/${id}`,
  type: 'card',
  access: ['*'],
  tabs: [
    {
      key: 'common',
      title: 'Общее',
      children: {
        left: [
          {
            key: 'title',
            title: 'Название',
            component: 'Input',
            placeholder: 'Введите',
            maxLength: 255,
            required: true,
          },
          {
            key: 'meta_keywords',
            title: 'Meta ключевые слова',
            component: 'Input',
            placeholder: 'Введите',
            maxLength: 255,
            required: false,
            showInSmallCard: true,
          },
          {
            key: 'meta_description',
            title: 'Meta описание',
            component: 'TextArea',
            placeholder: 'Введите текст',
            maxLength: 255,
            required: false,
          },
          {
            key: 'url',
            title: 'URL',
            component: 'Input',
            placeholder: 'Введите',
            maxLength: 255,
            required: true,
          },
          {
            key: 'hidden',
            title: 'Скрыть',
            component: 'Switch',
            defaultValue: 0,
          },
          {
            key: 'image_storage_id',
            title: 'Изображение (jpg)',
            component: 'Image',
            multiple: false,
            maxCount: 1,
            keyName: 'image_storage_id',
            keyList: 'image_storage',
            allowTypes: ['jpg'],
          },
          {
            key: 'tag_ids',
            title: 'Теги',
            component: 'DynamicSelect',
            endpoint: '/admin-search?filter=tags&sort[field]=name&sort[type]=asc&limit=200',
            disableFilterByValue: true,
            filter: 'tags',
            placeholder: 'Выберите теги',
            search: true,
            mode: 'multiple',
            getOptionValue: data => data.name,
            required: false,
          },
        ],
        right: [
          {
            key: 'title_en',
            title: 'Название (En)',
            component: 'Input',
            placeholder: 'Введите',
            maxLength: 255,
            required: false,
          },
          {
            key: 'meta_keywords_en',
            title: 'Meta ключевые слова (En)',
            component: 'Input',
            placeholder: 'Введите',
            maxLength: 255,
            required: false,
          },
          {
            key: 'meta_description_en',
            title: 'Meta описание (En)',
            component: 'TextArea',
            placeholder: 'Введите текст',
            maxLength: 255,
            required: false,
          },
        ],
        both: [],
      },
    },
    {
      key: 'content',
      title: 'Содержимое',
      children: {
        left: [],
        right: [],
        both: [
          {
            key: 'content',
            title: 'Содержимое',
            component: 'CKEditor',
            placeholder: 'Введите текст',
            required: false,
            isFixedHeight: false,
            height: '200px'
          },
          {
            key: 'content_footer',
            title: 'Подвал',
            component: 'CKEditor',
            placeholder: 'Введите текст',
            required: false,
            isFixedHeight: false,
            height: '200px'
          },
        ],
      },
    },
    {
      key: 'content_en',
      title: 'Содержимое (En)',
      children: {
        left: [],
        right: [],
        both: [
          {
            key: 'content_en',
            title: 'Содержимое',
            component: 'CKEditor',
            placeholder: 'Введите текст',
            required: false,
            isFixedHeight: false,
            height: '200px'
          },
          {
            key: 'content_footer_en',
            title: 'Подвал',
            component: 'CKEditor',
            placeholder: 'Введите текст',
            required: false,
            isFixedHeight: false,
            height: '200px'
          },
        ],
      },
    }
  ],
}

export default config